import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';
import { ButtonBase, Icon, Spinner } from '@deerplusofficial/pos-components';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';

const Container = styled(ButtonBase)`
  margin-top: 20px;
  padding: 14px 16px 14px 19px;
  width: 100%;
  border-radius: 6px;
  ${({ active }) =>
    active
      ? css`
          color: ${color.text.primary};
          background-color: rgba(255, 255, 255, 0.99);
        `
      : css`
          color: #ffffff;
          border: 1px solid #ffffff;
        `};
`;

const ButtonInner = styled.div`
  display: flex;
  justify-content: ${props => (props.loading ? 'center' : 'space-between')};
  flex-wrap: wrap;
  align-items: ${props => (props.active ? 'stretch' : 'center')};
  font-size: 16px;
  line-height: 1;
`;

const ButtonName = styled.div`
  font-size: 40px;
  text-align: left;
`;

const Next = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1 0;
  white-space: nowrap;
`;

const NextIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 10px;
  border-radius: 50%;
  background-color: #d8d8d8;
`;

const NextIcon = styled(Icon).attrs({ icon: 'chevron-right' })`
  position: relative;
  left: 1px;
  color: ${color.text.primary};
`;

const NextText = styled.div`
  flex-shrink: 0;
  ${({ active }) =>
    active &&
    css`
      color: ${color.text.secondary};
    `};
`;

const NextAvatar = styled.img`
  display: block;
  order: -1;
  margin-right: 10px;
  border-radius: 50%;
`;

const ForceSignout = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
  width: 100%;
  text-align: right;
  font-size: 14px;
  color: #f55753;
`;

const ForceSignoutIcon = styled(Icon).attrs({ icon: 'sign-out-alt' })`
  margin-right: 5px;
`;

class PosButton extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    displayOrder: PropTypes.number,
    user: PropTypes.shape({
      name: PropTypes.string,
      avatar: PropTypes.string,
    }),
    channelId: PropTypes.string,
    client: PropTypes.shape({}),
    onRefetch: PropTypes.func,
  };

  static defaultProps = {
    channelId: '',
    client: {},
    onRefetch: _.identity,
  };

  state = {
    loading: false,
  };

  onClick = async () => {
    const { id, pathTo, history, onRefetch, client } = this.props;

    this.setState({ loading: true });

    if (this.isInUse) {
      await client.onLogoutPointOfSale(id);

      await onRefetch();

      return this.setState({ loading: false });
    }

    await client.onLoginPointOfSale(id);

    history.push(pathTo.main);
  };

  get isInUse() {
    return _.size(this.props.user) > 0;
  }

  render() {
    const { loading } = this.state;
    const { name, displayOrder, user } = this.props;
    const { isInUse } = this;

    return (
      <Container onClick={this.onClick} active={isInUse}>
        <ButtonInner active={isInUse} loading={loading}>
          {loading ? (
            <Spinner dark />
          ) : (
            <React.Fragment>
              <ButtonName>{[name, displayOrder].join('')}</ButtonName>
              <Next>
                <NextText active={isInUse}>
                  {isInUse
                    ? [user.first_name, user.last_name].join(' ')
                    : '開始收銀'}
                </NextText>
                {isInUse ? (
                  _.size(user.avatar) > 0 && (
                    <NextAvatar src={user.avatar} width={32} height={32} />
                  )
                ) : (
                  <NextIconWrapper>
                    <NextIcon />
                  </NextIconWrapper>
                )}
              </Next>
              {isInUse && (
                <ForceSignout>
                  <ForceSignoutIcon />
                  強制登出
                </ForceSignout>
              )}
            </React.Fragment>
          )}
        </ButtonInner>
      </Container>
    );
  }
}

export default fp.compose(
  withRouter(),
  withClient()
)(PosButton);



// WEBPACK FOOTER //
// ./src/pages/Login/PosButton.js